import type { AssistantOrbConfig } from "@/types/ai-assistant-orb";

const URL_ORB = "/api/admin/ai-assistant/orb/";

/** Galat baca/simpan tampilan orb; 404 = endpoint belum ada di server ini. */
export class OrbApiError extends Error {
	constructor(
		message: string,
		readonly status: number,
	) {
		super(message);
		this.name = "OrbApiError";
	}
}

async function parse(res: Response): Promise<AssistantOrbConfig> {
	const isJson = res.headers.get("content-type")?.includes("application/json");
	const body = isJson
		? ((await res.json().catch(() => ({}))) as {
				orb?: AssistantOrbConfig;
				error?: string;
				message?: string;
			})
		: {};
	if (!res.ok)
		throw new OrbApiError(
			body.error ?? body.message ?? res.statusText,
			res.status,
		);
	if (!isJson || !body.orb)
		throw new OrbApiError("Endpoint orb tidak tersedia", 404);
	return body.orb;
}

const send = (
	method: string,
	config?: AssistantOrbConfig,
	signal?: AbortSignal,
) =>
	fetch(URL_ORB, {
		method,
		signal,
		...(config === undefined
			? {}
			: {
					headers: { "content-type": "application/json" },
					body: JSON.stringify(config),
				}),
	});

/** Tampilan orb yang tersimpan (server mengembalikan bawaan bila belum disetel). */
export async function fetchOrb(signal?: AbortSignal) {
	return parse(await send("GET", undefined, signal));
}

/** Simpan tampilan orb; server menjepit parameter di luar rentang. */
export async function saveOrb(config: AssistantOrbConfig) {
	return parse(await send("PUT", config));
}

/** Kembalikan ke tampilan bawaan. */
export async function resetOrb() {
	return parse(await send("DELETE"));
}
